import cookies from "js-cookie";
let config = {};

if (process.env.BUILD_ENV === "prod") {
    config = require("./prod").default;
}
if (process.env.BUILD_ENV === "dev") {
    config = require("./dev").default;
}
if (process.env.BUILD_ENV === "slot") {
    config = require("./slot").default;
}

config.platform = function () {
    if (process.env.BUILD_TARGET === "mobileweb") {
        return "MOBILE_WEB";
    }
    const ostype = cookies.get("AppType");
    if (ostype === "AOS") {
        return "AOS";
    }
    return "IOS";
};

// Local 개발시 플래그 활성화
config.isLocalDevelopment = false;

// 미국향 여부
config.isUS = process.env.COUNTRY === "US" ? true : false;

// 스토리지 URL
if (config.isUS) {
    config.korotStorageApiBaseUrl = config.korotStorageApiBaseUrl_US;
} else {
    config.korotStorageApiBaseUrl = config.korotStorageApiBaseUrl_KR;
}

// stores/signalRConfig.js에서 storeId 확인 후 배포
export default config;
